module.exports = __webpack_public_path__ + "static/media/養生麻油猴頭菇.ba2f698e.jpg";